import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { API } from "../lib/api";

const getVisitorId = () => {
  let v = localStorage.getItem("hf_vid");
  if (!v) {
    v = window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("hf_vid", v);
  }
  return v;
};

const VisitorHeartbeat = () => {
  const location = useLocation();
  const { lang, currency } = useApp();

  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return undefined;
    const ping = () => {
      const ctok = localStorage.getItem("hf_customer_token");
      fetch(`${API}/visitors/ping`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(ctok ? { Authorization: `Bearer ${ctok}` } : {}),
        },
        body: JSON.stringify({ visitor_id: getVisitorId(), path: location.pathname, lang, currency }),
        keepalive: true,
      }).catch(() => {});
    };
    ping();
    const timer = setInterval(ping, 20000);
    return () => clearInterval(timer);
  }, [location.pathname, lang, currency]);

  return null;
};

export default VisitorHeartbeat;
